import { render, staticRenderFns } from "./AliasesView.vue?vue&type=template&id=663c61b5&"
import script from "./AliasesView.vue?vue&type=script&lang=js&"
export * from "./AliasesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663c61b5')) {
      api.createRecord('663c61b5', component.options)
    } else {
      api.reload('663c61b5', component.options)
    }
    module.hot.accept("./AliasesView.vue?vue&type=template&id=663c61b5&", function () {
      api.rerender('663c61b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/AliasesView.vue"
export default component.exports